import React, { useEffect, useState } from 'react';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Card } from '@uhg-abyss/web/ui/Card';
import { useLazyGetFamilyExchangeDetailsQuery } from '@src/store/services/cdb/onlineServices';
import { Table } from '@src/common/Table';
import { maskUsingUserAccess } from '@src/utils';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { encdata } from '@src/constants';
import CryptoJS from 'crypto-js';

import { useAuth } from '@src/Providers/AuthProvider';

export const MultiLevelView = () => {
  const router = useRouter();
  const [params, setParams] = useState();

  const { user } = useAuth();

  const { encryptedData } = router.getRouteParams();

  useEffect(() => {
    if (encryptedData) {
      const decryptedData = CryptoJS.AES.decrypt(
        decodeURIComponent(encryptedData),
        encdata
      ).toString(CryptoJS.enc.Utf8);
      const linkData = JSON.parse(decryptedData);

      const obj = {
        customerName: linkData?.customerName,
        empId: linkData?.empId,
        sbmtGrpName: linkData?.sbmtGrpName,
        processingDt: linkData?.processingDt,
        sbmtGrpId: linkData.sbmtGrpId,
        cescustnbr: linkData.cescustnbr,
        fileId: linkData.fileID,
        setId: linkData.transSetId,
        reportType: linkData.reportType,
        subscrId: linkData?.subscrId,
      };

      setParams(obj);
      ///${fileData?.transSetId}/${row?.original?.subscrId}/${fileData?.sbmtGrpName}/${fileData?.processingDt}/${fileData?.sbmtGrpId}/${fileData?.cescustnbr}/AT`
    }
  }, [encryptedData]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'Severity',
        accessor: 'severityCode',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 80,
        width: 80,
      },
      {
        Header: 'Employee ID',
        accessor: 'subscrId',
        canToggleVisibilty: false,
        isHiddenByDefault: false,
        minWidth: 100,
        width: 100,
        Cell: ({ row }) => {
          const { subscrId, employeeId } = row.original;
          return subscrId || employeeId || '';
        },
      },
      {
        Header: 'Trans Id',
        accessor: 'transId',
        canToggleVisibilty: false,
        isHiddenByDefault: true,
        minWidth: 100,
        width: 100,
      },
      {
        Header: 'Name',
        accessor: 'name',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 100,
        width: 100,
      },
      {
        Header: 'Rel',
        accessor: 'relationship',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 50,
        width: 50,
        Cell: ({ row }) => {
          const { relationship, rel } = row.original;
          return relationship || rel || '';
        },
      },
      {
        Header: 'Coverage Type',
        accessor: 'covType',
        minWidth: 80,
        width: 80,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
      },
      {
        Header: 'Status',
        accessor: 'stsTxt',
        minWidth: 85,
        width: 85,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        Cell: ({ row }) => {
          const { stsTxt, status } = row.original;
          return stsTxt || status || '';
        },
      },
      {
        Header: 'Type',
        accessor: 'type',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 130,
        width: 130,
      },
      {
        Header: 'Transaction Source',
        accessor: 'transactionSource',
        minWidth: 85,
        width: 85,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
      },
      {
        Header: 'Error Name',
        accessor: 'warningName',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 100,
        width: 100,
      },
      {
        Header: 'Data field',
        accessor: 'dataField',
        minWidth: 100,
        width: 100,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
      },

      {
        Header: 'Customer Data',
        accessor: 'custData',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 100,
        width: 100,
        cell: ({ row, value }) => {
          return maskUsingUserAccess(
            value,
            row?.original?.dataField || '',
            user?.maskingType || 0
          );
        },
      },
      {
        Header: 'Source Data',
        accessor: 'sourceData',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 100,
        width: 100,
        cell: ({ row, value }) => {
          return maskUsingUserAccess(
            value,
            row?.original?.dataField || '',
            user?.maskingType || 0
          );
        },
      },

      {
        Header: 'Detail View',
        accessor: 'detailView',
        enableSorting: false,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 90,
        width: 90,
        Cell: ({ row }) => {
          const nameSplit = row?.original?.name.split(',');
          const firstName = nameSplit[1].trim();
          const lastName = nameSplit[0].trim();
          const detailViewLink = `/home/detail-view/`;

          const linkData = {
            fileID: params?.fileId,
            transSetId: params?.setId,

            firstName: firstName,
            lastName: lastName.trim(),

            customerName: params?.customerName,

            transId: row?.original?.transId,
            subscrId: row?.original?.subscrId,

            relationship: row?.original?.relationship,
            cescustnbr: params?.cescustnbr,
            processingDt: params.processingDt,

            // Add other parameters as needed
          };

          const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(linkData),
            encdata
          ).toString();

          const newUrl = `${detailViewLink}${encodeURIComponent(
            encryptedData
          )}`;

          return (
            <Flex
              css={{
                gap: '10px',
              }}
            >
              <Link
                size="$sm"
                target="_blank"
                href={newUrl}
                onClick={(e) => {
                  e.preventDefault();
                  window.open(newUrl, 'DetailViewTab');
                }}
              >
                <Button
                  variant="outline"
                  size="$sm"
                  css={{
                    fontSize: '12px',
                  }}
                >
                  <strong>Detail View</strong>
                </Button>
              </Link>
            </Flex>
          );
        },
      },
    ],
    [params]
  );

  // if (isLoading) {
  //   return <div>Loading...</div>;
  // }

  // if (error) {
  //   return <div>Error: {error.message}</div>;
  // }

  return (
    <React.Fragment>
      <Card>
        <div style={{ padding: '16px' }}>
          <div>
            <h3> Multiple Member Transaction Processing</h3> <br />
            <strong>Customer Submission Group:</strong> {params?.customerName}{' '}
            <br />
            <strong>Processing Date:</strong> {params?.processingDt} <br />
            <strong>Employee ID:</strong> {params?.fileId}
          </div>
          {params && (
            <Table
              columns={columns}
              dataKey="fileListTable"
              fetch={useLazyGetFamilyExchangeDetailsQuery}
              requestParams={params}
              showGlobalFilter={false}
              showPagination={false}
            />
          )}
        </div>
      </Card>
    </React.Fragment>
  );
};
